<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
      data-cy="menu-date">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field ref="campo"
          v-bind="{...attrs, ...dateAttrs}"
          :value="$api.UI.Format.Date(date, format)"
          :label="labelDefault"
          prepend-inner-icon="event"
          :rules="rules"
          v-mask="['##/##/####']"
          maxlength="10"
          format="datetext"
          autocomplete="off"
          type="tel"
          pattern="[0-9]*"
          @click:clear="clear"
          @input="handleTextInput"
          @blur="handleTextBlur"
          @keyup.tab="menu = true"
          @keydown.tab="menu = false"
          v-on="on"
          data-cy="text-date">
          <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
            <slot :name="slotName" v-bind="context" />
          </template>
          <template v-for="(_, name) in $slots" v-slot:[name]>
            <slot :name="name" />
          </template>
          <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
            <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}</v-icon>
            <span v-html="message" :key="key"></span>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        :active-picker.sync="activePicker"
        v-bind="dateAttrs"
        no-title
        :max="max"
        :min="min"
        ref="picker"
        locale="pt-br"
        v-model="date"
        @input="menu = false"
        :data-cy="$attrs.label || $attrs.name">
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import { isValid, parseISO } from 'date-fns'

export default {
  props: {
    value: null,
    format: { default: 'dd/MM/yyyy' },
    min: { default: new Date(0).toISOString().substr(0, 10) },
    max: { default: new Date().toISOString().substr(0, 10) },
    tipo: { default: 'diario' }
  },
  data: () => ({
    menu: false,
    activePicker: null
  }),
  computed: {
    labelDefault: function () {
      return (
        this.$attrs.label ? this.$attrs.label +
        (this.$attrs.required === '' || this.$attrs.required === true ? ' *' : '')
          : ''
      )
    },
    date: {
      get () {
        if (this.value) {
          var val = new Date(Date.parse(this.value))
            .toISOString()
            .substr(0, 10)
          return val
        }
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    dateAttrs () {
      return { ...this.$theme.options, ...this.$theme.options.date, ...this.$attrs }
    },
    rules () {
      const errors = []
      const name = this.$attrs.name || this.$attrs.label || ''
      if (this.$attrs.required === '' || this.$attrs.required === true) {
        !!this.date || errors.push(name + ' é obrigatório.')
      }

      this.$api.UTIL.Functions.ValidateFormRules(this.$attrs.rules, errors, this.date)

      if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
        this.$refs.campo.$el.setAttribute(
          'data-message',
          errors ? errors[0] : ''
        )
        this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
      }
      return errors
    }
  },
  methods: {
    handleTextInput (val) {
      if (val?.length !== 10) {
        return
      }

      const [day, month, year] = val.split('/')
      const date = `${year}-${month}-${day}`
      const isValidDate = isValid(parseISO(date, 'yyyy-MM-dd'))
      const isWithinRange = (this.min ? date >= this.min : true) && (this.max ? date <= this.max : true)

      if (isValidDate && isWithinRange) {
        this.date = date
      }
    },
    handleTextBlur () {
      const { lazyValue } = this.$refs.campo
      const [day, month, year] = lazyValue ? lazyValue.split('/') : []
      const date = `${year}-${month}-${day}`
      const isValidDate = isValid(parseISO(date, 'MM/dd/yyyy'))
      const isWithinRange = (this.min ? date >= this.min : true) && (this.max ? date <= this.max : true)
      const shouldReset = !isValidDate || !isWithinRange

      if (shouldReset) {
        this.$refs.campo.lazyValue = this.$api.UI.Format.Date(this.date, this.format)
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clear () {
      if (this.$attrs.clearable !== null) {
        this.date = null
      }
    },
    validar () {}
  },
  watch: {
    menu (val) {
      if (this.$attrs['active-picker']) {
        setTimeout(() => (this.activePicker = this.$attrs['active-picker']))
        return
      }
      if (this.$attrs.anual === '') {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
        return
      } else if (this.$attrs.mensal === '') {
        val && setTimeout(() => (this.activePicker = 'MONTH'))
        return
      }

      // obsoleto
      switch (this.$attrs.tipo) {
        case 'anual':
          val && setTimeout(() => (this.activePicker = 'YEAR'))
          break
        default:
          break
      }
    },
    date (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.$nextTick(function () {
      const errors = this.rules
      this.$refs.campo.$el.setAttribute(
        'data-message',
        errors ? errors[0] : ''
      )
      this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
    })
  }
}
</script>
